import './AppLabelCellEditor.scss';

import classNames from 'classnames';
import { PlaintextCellEditor } from '@ui/text';

import { APP_VALIDATION_RULES, setNameAndLabelConflictMessage } from '../../@arch/validation';
import React, { useCallback, useMemo, useState } from 'react';
import { useAsyncProcessing, useCurrentUser, useUpdateDataSecurityApp } from '@hooks';

export interface AppLabelCellEditorProps {
	applicationId: number;
	label?: string;
}

export const AppLabelCellEditor: React.FC<AppLabelCellEditorProps> = ({ applicationId, label }) => {
	const [ newLabel, setNewLabel ] = useState(label);
	const { request, reset } = useUpdateDataSecurityApp();
	const { isReadOnly } = useCurrentUser();

	const statusCodeHandlers = useMemo(() => setNameAndLabelConflictMessage(newLabel ?? ''), [ newLabel ]);

	const process = useAsyncProcessing({
		resetAction: reset,
		stateSelector: useUpdateDataSecurityApp.selectors.state,
		statusCodeHandlers
	});

	const handleOnSave = useCallback((value?: string) => {
		if (label === value) {
			return;
		}

		setNewLabel(value);

		process.watchNextCall();

		request({
			applicationId,
			label: value
		});
	}, [ applicationId, label, process, request ]);

	return (
		<PlaintextCellEditor
			className={ classNames('app-label-cell-editor', { readonly: isReadOnly }) }
			isProcessing={ process.state.isProcessing }
			onSave={ handleOnSave }
			onStartEditing={ process.reset }
			processingResult={ process.state.result }
			rules={ APP_VALIDATION_RULES.LABEL }
			skipSpellcheck
			value={ label } />
	);
};
